// ボタン中央寄せ用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';
var RowCenterButton = function (_a) {
    var children = _a.children;
    return (React.createElement(Row, { className: "row-center-button" },
        React.createElement(Col, { className: "text-center" }, children)));
};
export default RowCenterButton;
